import { FC, useCallback } from 'react';
import { IActivities, IMyActivity } from '../../../types/activities.types';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Button } from '../../../components/Button';
import dayjs from 'dayjs';
import { isSameDate } from '../../../services/utils/dateConvert';
import { convertToAmPm } from '../../../services/utils';
import { DATE_TYPE } from '../../../constants/activity';

interface MyActivityItemProps {
  item: IMyActivity;
}

const MyActivityItem: FC<MyActivityItemProps> = ({ item }) => {
  const isDesktop = useIsDesktop();

  const handleRedirectDetail = useCallback(() => {
    NavigationService.push('Root', {
      screen: 'MenuTab',
      params: {
        screen: 'MyActivitiesDetail',
        params: {
          id: item.id,
        },
      },
    });
  }, [item.id]);

  return (
    <View
      style={[
        {
          paddingBottom: 25,
        },
        !isDesktop() && {
          borderBottomWidth: 1,
          borderBottomColor: COLORS.GREY,
        },
      ]}
    >
      <Text
        style={{
          fontFamily: FONTS.Arial,
          fontWeight: '700',
          fontSize: 20,
          letterSpacing: 1.7,
          color: COLORS.BLACK,
          textTransform: 'uppercase',
          borderBottomWidth: 1,
          paddingBottom: 15,
          marginBottom: 15,
          borderBottomColor: COLORS.GREY,
        }}
        onPress={() => {
          handleRedirectDetail();
        }}
      >
        {item.camp.name}
      </Text>
      {/* <Text
        style={{
          fontFamily: FONTS.AvenirMedium,
          fontWeight: '500',
          fontSize: 16,
          color: COLORS.GREY,
          marginBottom: 10,
        }}
      >
        {item.date}
      </Text> */}
      <View style={{ flexDirection: isDesktop() ? 'row' : 'column', gap: 15 }}>
        <TouchableOpacity
          onPress={() => {
            handleRedirectDetail();
          }}
        >
          <Image
            source={
              item.image
                ? { uri: item.image }
                : require('../../../assets/activities_image/image-1.png')
            }
            style={{
              width: isDesktop() ? 312 : '100%',
              height: 175,
              borderRadius: 18,
            }}
          />
        </TouchableOpacity>
        <View
          style={{
            flex: 1,
          }}
        >
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '800',
              fontSize: 19,
              letterSpacing: 1,
              marginBottom: 10,
              color: COLORS.BLACK,
            }}
            onPress={() => {
              handleRedirectDetail();
            }}
          >
            {item.name}
          </Text>
          <View
            style={{
              width: 58,
              height: 2,
              backgroundColor: COLORS.RED_PRIMARY,
              marginBottom: 10,
            }}
          />
          {/* <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '500',
              fontSize: 15,
              color: COLORS.GREY,
              letterSpacing: 1,
              marginBottom: 10,
            }}
          >
            {item.other}
          </Text>
          <View style={{ flexDirection: 'row' }}>
            <View
              style={{
                borderRadius: 18,
                paddingVertical: 2,
                paddingHorizontal: 5,
                backgroundColor: COLORS.SWEET_RED,
                flexDirection: 'row',
                marginBottom: 10,
              }}
            >
              <Text
                style={[
                  {
                    fontFamily: FONTS.AvenirMedium,
                    fontWeight: '500',
                    fontSize: isDesktop() ? 15 : 12,
                    textAlign: 'center',
                    color: COLORS.WHITE,
                  },
                  !isDesktop() && {},
                ]}
              >
                {item.hour}
              </Text>
            </View>
          </View> */}
          {item.date_type.value === DATE_TYPE.NORMAL ? (
            item.start_date === item.end_date ? (
              <Text style={styles.subText}>
                {`${dayjs(item.start_date).format('MMMM DD, YYYY')}`}
              </Text>
            ) : (
              <>
                <Text style={styles.subText}>
                  {`Start: ${dayjs(item.start_date).format('MMMM DD, YYYY')}`}
                </Text>
                <Text style={styles.subText}>
                  {`End: ${dayjs(item.end_date).format('MMMM DD, YYYY')}`}
                </Text>
              </>
            )
          ) : (
            <Text style={styles.subText}>{item.date_type.name}</Text>
          )}
          <View
            style={{
              borderRadius: 18,
              paddingVertical: 2,
              paddingHorizontal: 15,
              backgroundColor: COLORS.RED_PRIMARY,
              width: 100,
              marginBottom: 10,
            }}
          >
            <Text
              style={{
                fontFamily: FONTS.AvenirMedium,
                fontSize: 12,
                fontWeight: '500',
                color: COLORS.WHITE,
                textAlign: 'center',
                lineHeight: 18,
              }}
            >
              {`${convertToAmPm(item.start_time)} - ${convertToAmPm(
                item.end_time
              )}`}
            </Text>
          </View>
          <Text style={styles.subText}>{item.type}</Text>
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '500',
              fontSize: 15,
              color: COLORS.GREY,
              letterSpacing: 1,
              marginBottom: 10,
            }}
          >
            {item.venue}
          </Text>
          <View
            style={{
              flexDirection: 'row',
              gap: isDesktop() ? 15 : 8,
              alignItems: 'center',
            }}
          >
            <Button
              text="Read more"
              className=""
              style={{
                borderRadius: 12,
                paddingHorizontal: isDesktop() ? 40 : 30,
                paddingVertical: isDesktop() ? 7 : 8,
                backgroundColor: COLORS.RED_PRIMARY,
              }}
              textStyle={{
                textTransform: 'uppercase',
                fontFamily: FONTS.AvenirMedium,
                fontWeight: isDesktop() ? '800' : '500',
                fontSize: isDesktop() ? 16 : 16,
                textAlign: 'center',
                color: COLORS.WHITE,
                letterSpacing: 2,
              }}
              arrowRight={false}
              onPress={() => {
                handleRedirectDetail();
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default MyActivityItem;

const styles = StyleSheet.create({
  subText: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 15,
    color: COLORS.GREY,
    letterSpacing: 1,
    marginBottom: 10,
  },
});
